import { render, staticRenderFns } from "./wechat-category.vue?vue&type=template&id=730f7fdf&"
import script from "./wechat-category.vue?vue&type=script&lang=js&"
export * from "./wechat-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports